import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SmartDownloadButton } from './SmartDownloadButton';
import { buildPath } from '../routing';
import { normalizeLanguage } from '../i18n/utils';
import { ScrollReveal } from './ScrollReveal';

export function CTA() {
  const { t, i18n } = useTranslation();
  const currentLang = normalizeLanguage(i18n.language);
  const downloadPagePath = buildPath(currentLang, 'download');
  const pricingPath = buildPath(currentLang, 'pricing');
  const contactPath = buildPath(currentLang, 'contact');

  return (
    <section id="cta" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <ScrollReveal>
          <a href={contactPath} className="text-gray-900 hover:text-teal-700 transition-colors">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              {t('cta.title')}
            </h2>
          </a>
        </ScrollReveal>
        <ScrollReveal delay={1}>
          <p className="text-xl text-gray-600 mb-10">
            {t('cta.subtitle')}
          </p>
        </ScrollReveal>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-start">
          <ScrollReveal delay={2}>
            <div className="flex flex-col items-center">
              <SmartDownloadButton variant="primary" />
              <a
                href={downloadPagePath}
                className="mt-4 text-sm text-gray-500 hover:text-teal-700 transition-colors flex items-center gap-2"
              >
                <ChevronRight className="size-4" />
                {t('cta.allVersionsLink')}
              </a>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={3}>
            <a
              href={pricingPath}
              className="bg-white hover:bg-gray-50 text-teal-600 border-2 border-teal-600 px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
            >
              {t('cta.secondary')}
            </a>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
